import { render, staticRenderFns } from "./list-take.vue?vue&type=template&id=81703be2&scoped=true&"
import script from "./list-take.vue?vue&type=script&lang=js&"
export * from "./list-take.vue?vue&type=script&lang=js&"
import style0 from "./list-take.vue?vue&type=style&index=0&id=81703be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81703be2",
  null
  
)

export default component.exports